module.exports = __webpack_public_path__ + "static/img/yuxiaohu.553858f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/yuxiaohu.jpg
// module id = 9jT0
// module chunks = 2